<template>
	<div class="imgText">
		<div class="warp">
			<div class="banner">
				<img src="../static/8_1.png" alt="">
			</div>
			<div class="title">
				<span>第二部分</span>
				<h3>帕埃斯图姆的彩绘墓室</h3>
				<em style="width:70%"></em>
			</div>
			<div class="warplist">
				<ul>
					<div class="topline"></div>
					<li>
						<router-link tag="a" :to="{path:'indexT',query:{id:14}}">
							<span class="wap"><span class="number">2.1 </span>地下之旅 </span>
						</router-link>
						<dl><dd></dd></dl>
					</li>
					<li>
						<router-link tag="a" :to="{path:'indexT',query:{id:15}}">
							<span class="wap"><span class="number">2.2 </span>卢卡尼亚人的登场</span>
						</router-link>
						<dl><dd></dd></dl>
						<router-link tag="a" :to="{path:'indexT',query:{id:16}}">
							<p>
								<em class="vertical-circle"></em>
								<span><span class="number">2.2.1 </span>卢卡尼亚人的“精神”</span>
							</p>
						</router-link>
						<router-link tag="a" :to="{path:'indexT',query:{id:17}}">
							<p>
								<em class="vertical-circle"></em>
								<span><span class="number">2.2.2 </span>卢卡尼亚-帕埃斯图姆的女性</span>
							</p>
						</router-link>
					</li>
					<li>
						<router-link tag="a" :to="{path:'indexT',query:{id:18}}">
							<span class="wap"><span class="number">2.3 </span>帕埃斯图姆之墓</span>
						</router-link>
						<dl><dd></dd></dl>
					</li>
					<li>
						<router-link tag="a" :to="{path:'indexT',query:{id:19}}">
							<span class="wap"><span class="number">2.4 </span>帕埃斯图姆的重新发现</span>
						</router-link>
						<dl><dd></dd></dl>
						<router-link tag="a" :to="{path:'indexT',query:{id:20}}">
							<p>
								<em class="vertical-circle"></em>
								<span><span class="number">2.4.1 </span>跳水者之墓</span>
							</p>
						</router-link>
						<router-link tag="a" :to="{path:'indexT',query:{id:21}}">
							<p>
								<em class="vertical-circle"></em>
								<span><span class="number">2.4.2</span>隐喻及神秘</span>
							</p>
						</router-link>
					</li>
					<div class="bottomline"></div>
				</ul>
			</div>
		</div>
		<div class="goback" @click="goback"></div>
	</div>
</template>
<script type="text/javascript">
	export default {
		data(){
			return{
				isActive:false,
				msg:'展开',
				tabTitle: ['海昏传说', '侯国探秘'],
				curdata:'',
				allData:{
					"data0":{
						data:[{
							id:1,
							title:'海昏传说 前言'	
						},{
							id:2,
							title:'郡国并行制'	
						},{
							id:3,
							title:'海昏县与海昏国'	
						},{
							id:4,
							title:'鄱阳湖与海昏县'
						}]
					},
					"data1":{
						data:[{
							id:5,
							title:'侯国探秘 前言'	
						},{
							id:6,
							title:'紫金城'	
						},{
							id:7,
							title:'刘贺墓园'	
						},{
							id:8,
							title:'刘贺墓'	
						}]
					},
				},
				cur: 0 //默认选中第一个tab
			}
		},
		mounted(){
			this.curdata=this.allData['data0'];
		},
		methods:{
			slidUp(){
				this.isActive=!this.isActive;
				if (this.isActive) {
					this.msg='收起'
				}else{
					this.msg='展开'
				}
			},
			tabdata(index){
				this.cur=index;
				var code='data'+index;
				this.curdata=this.allData[code];
				//console.log(this.curdata,456)
			},
			goback(){
				this.$router.go(-1)
			}
		}
	}
</script>
<style scoped>
	#audio{
		display: block;
		margin: 0 auto;
		margin-top: .3rem;
		margin-bottom: .3rem;
	}
	.number{
		display: inline-block;
		width: .5rem;
	}
	.goback{
		width: 0.62rem;
		height: 0.62rem;
		background:url(../static/g.png);
		background-size: 100% 100%;
		border-radius:100%;
		position: fixed;
		right: 20px;
		top: 60%;
	}
	.warp{
		width: 90%;
		margin: 0 auto;
		background:#fff;
		box-shadow: 0px 1px 15px #ededed;
		margin-top: 20px;
		border-radius:20px;
		padding-bottom:1rem;
		margin-bottom: 1rem;
	}
	.warplist{
		width: 100%;
		margin-top: 0.25rem;
	}
	.warplist ul{
		margin-left: 0.25rem;
		position: relative;
	}
	.warplist ul .topline{
		width: 1px;
		height: 20px;
		position: absolute;
		background: #fff;
		top: -4px;
		z-index: 999; 
	}
	.warplist ul .bottomline{
		width: 1px;
		height: 26px;
		position: absolute;
		background: #fff;
		bottom:2px;
		z-index: 999; 
	}
	.warplist ul li{
		font-size:16px;
		color:#ebc37d;
		font-weight: bold;
		line-height:45px;
		border-left: 1px solid #dddddd;
		position: relative;
	}
	.warplist ul li .wap{
		display: inline-block;
		margin-left: 0.25rem;
		height: 45px;
		line-height: 27px;
		margin-top: 10px;
		padding-right: 10px;
		color:#ebc37d;
	}
	.warplist ul li dl{
		position: absolute;
		width:14px;
		height:14px;
		background:#ebc37d;
		border-radius:100%;
		left:-0.075rem;
		top: 16px;
		box-shadow: 0px 0px 3px #ccc;
	}
	.warplist ul li dl dd{
		width:8px;
		height:8px;
		background:#fff;
		border-radius:100%;
		margin: 0 auto;
		margin-top:3px;
	}
	.warplist ul li p{
		position: relative;
		font-size: 15px;
		font-weight: normal;
		color:#466c75;
		margin-left: 0.25rem;
	}
	.warplist ul li p span{
		display: inline-block;
		height: 45px;
		line-height: 27px;
	}
	.vertical-circle{
		position: absolute;
		width: 7px;
		height: 7px;
		border: 2px solid white;
		background: #ebc37d;
		border-radius: 100%;
		left: -0.31rem;
		top: 18px;
		-webkit-box-shadow: 0px 0px 14px #ccc;
		box-shadow: 0px 0px 6px #ccc;
	}
	.banner{
		width: 100%;
		border-top-left-radius:20px;
		border-top-right-radius:20px;
		margin-bottom: 0.1rem;
	}
	.banner img{
		width: 100%;
		border-top-left-radius:20px;
		border-top-right-radius:20px;
	}
	.title{
		display: flex;
		width:80%;
		height:.8rem;
		font-size:20px;
		background:url(../static/tit.png) no-repeat;
		background-size:contain;
		position: relative;
		margin: 0 auto;
	}
	.title span{
		font-size: 14px;
		color:#fff;
		text-indent:0.07rem;
		line-height:50px;
		letter-spacing: 3px;
		display: inline-block;
		z-index: 3;
		position: absolute;
	}
	.title h3{
		width: 100%;
		text-align:center;
		font-size:18px;
		font-weight: bold;
		color:#466c75;
		line-height: .9rem;
		text-indent:.55rem;
	}
	.title em{
		display: inline-block;
		width: 41%;
		height: 1px;
		background: #ccc;
		position: absolute;
		bottom: 17px;
		left: 32%;
	}
	.cont{
		width: 90%;
		margin: 0 auto;
	}
	.cont p{
		font-size: 16px;
		color:#666666;
		line-height: 30px;
		text-align: justify;
		margin-bottom: .10rem;
	}
	.cont dl{
		width: 100%;
		margin-bottom:.10rem;
	}
	.cont dl dt img{
		width: 100%;
	}
	.cont dl dd{
		font-size:14px;
		color:#adadad;
		margin-top: 0.15rem;
		line-height: 20px;
	}
	.butn{
		background:url(../static/bj1.png);
		height:.4rem;
		background-size: 100%;
		margin-top:.25rem;
		position: relative;
	}
	.btnC{
		width: 0.45rem;
		height: 0.23rem;
		border-radius: 50px;
		background:#fff;
		box-shadow: 0px 1px 15px #ededed;
		text-align: center;
		line-height: 0.23rem;
		margin: 0 auto;
		margin-top: -0.11rem;
		position: absolute;
		left: 50%;
		margin-left: -0.25rem;
		color:#e6bb70;
	}
	.activeClass{
		height: 2rem;
		overflow:hidden;
	}
	.hideClass{
		height: auto;
	}
	.tab-tilte{
	    width:1500px;
	}
	.tab-tilte li{
	    float: left;
	    width:1rem;
	    padding: 10px 0;
	    text-align: center;
	    cursor: pointer;
	    color:#cdcdcd;
	    font-size: 18px;
	    font-weight: bold;
	}
	/* 点击对应的标题添加对应的背景颜色 */
	.tab-tilte .active{
	    color: #e6bb70;
	}
	.tab-content div{
	    width:95%;
	  	margin: 0 auto;
	  	margin-top:.2rem;
	  	margin-left:.1rem;
	}	
	.tab-content div p{
		font-size: 16px;
		color: #e6bb70;
		margin-bottom: 20px;
		padding-left: 20px;
	}
	.tab-content div p:before { 
	     content: '';
	     display: inline-block;
	     width: 10px;
	     height: 10px;
	     background:#e6bb70;
	     border-radius: 100%;
	     margin-right: 20px;
	}
</style>